import React, { useEffect, useState } from "react";
import { Container, Input, Label } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { useTable, usePagination, useGlobalFilter } from "react-table";
import viewbill from "../../../assets/images/Expenses/View_Bill.jpg";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Select from "react-select";
import { Table, Row, Col, Card, CardBody, Modal, Form } from "reactstrap";
import Pagination from "components/Common/Pagination";
import Loader from "pages/Separate/Loader";
import AccessDeniedPopup from "routes/AccessDeniedPopup";
import { zithasTaxInvoice } from "utils/columns/Finance/financeColumns";
import AddZithasInvoice from "./AddZithasInvoice";
import {
  fetchNodeData,
  FetchNodePostData,
  FetchNodeDeleteData,
  fetchData,
} from "utils/common-fetchData";
import secureLocalStorage from "react-secure-storage";
import {
  calculateFinancialYearTotals,
  checkPermissionsByModule,
  getFinancialYear,
} from "utils/common-helpers";
import { useSelector } from "react-redux";
import EditZithasInvoice from "./EditZithasInvoice";
import Swal from "sweetalert2";
import axios from "axios";
import configure from "configure";
import { colourStyles } from "utils/common-options";
import moment from "moment";
import Draggable from "react-draggable";
import { ResizableBox } from "react-resizable";
import { getFinancialYears } from "./ZtplTaxInvoice";
import { useSearchParams } from "react-router-dom";
import html2pdf from "html2pdf.js";
import zithasLogo from "../../../assets/images/zithas-dark-logo.png";

function getByFinancialYear(data = [], fYear = getFinancialYears(6)[0]) {
  const [start, end] = fYear?.split("-");
  return data?.filter(item =>
    (new Date(item.invoice_date) >= new Date(`${start}-04-01`)) &&
    (new Date(item.invoice_date) <= new Date(`${end}-03-31`)))
}

function TableContainer({
  columns,
  data,
  setDatas,
  setLoading,
  fetchInvoiceData,
  originalData,
  setOriginalData,
  currentYearData,
  setCurrentYearData
}) {
  const [fixedContent, setFixedContent] = useState(false);
  const [modal_fullscreen, setmodal_fullscreen] = useState(false);
  const [boxWidth, setBoxWidth] = useState(300);
  const navigate = useNavigate();
  const location = useLocation();
  const [tab, setTab] = useState(0);

  const [allOption, setAllOption] = useState({});
  const [filterPopup, setFilterPopup] = useState(false);

  const [fromDateFilter, setFromDateFilter] = useState(false);
  const [toDateFilter, setToDateFilter] = useState(false);
  const financialYears = getFinancialYears(6);
  const [selectedFY, setSelectedFY] = useState(financialYears[0]);
  const [activeFilter, setActiveFilter] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams();

  const initialSearch =
    searchParams.get("search") || "";

  const initialPage =
    Number(searchParams.get("page")) || 0;

  const initialPageSize =
    Number(searchParams.get("pageSize")) || 10;


  useEffect(() => {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") setmodal_fullscreen(false);
    });

    document.addEventListener("scroll", () => {
      if (window.scrollY > 165) {
        setFixedContent(true);
      } else {
        setFixedContent(false);
      }
    });
  }, []);

  const getValue = (value) =>
    Math.floor(parseFloat(value || 0) * 100) / 100

  const getInvoiceType = (item) => {
    const due = getValue(item.balance_due);
    const total = getValue(item.total);

    if (due <= 0) return "FULLY_PAID"
    if (due === total) return "UNPAID"
    if (due > 0 && due < total) return "PARTIAL"
    return "UNKNOWN"
  };

  //Filter by FY year
  useEffect(() => {
    if (selectedFY && originalData?.length) {
      const filtered = getByFinancialYear(originalData, selectedFY)
      setCurrentYearData(filtered);
    }

  }, [selectedFY, originalData]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    pageOptions,
    canNextPage,
    gotoPage,
    setPageSize,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      // Keep the search text when the rows change (switching between the
      // selected year and all years below).
      autoResetGlobalFilter: false,

      initialState: {
        pageIndex: initialPage,
        pageSize: initialPageSize,
        globalFilter: initialSearch,
      },
    },
    useGlobalFilter,
    usePagination,
  );

  const { pageIndex, pageSize, globalFilter } = state;

  // Search covers every year: while the search box has text, the table gets
  // all invoices (originalData) instead of only the selected financial year,
  // so an invoice from another year can still be found. The status tab still
  // applies. Clearing the search goes back to the selected year.
  const searchingAllYears = String(globalFilter || "").trim() !== "";

  // Filter tab-wise data from the selected year (or all years while searching)
  useEffect(() => {
    const base = searchingAllYears ? originalData || [] : currentYearData;
    let filtered = [];

    switch (tab) {
      case 0:
        filtered = base;
        break;

      case 1:
        filtered = base.filter(
          (item) => getInvoiceType(item) === "FULLY_PAID",
        );
        break;

      case 2:
        filtered = base.filter(
          (item) => getInvoiceType(item) === "PARTIAL",
        );
        break;

      case 3:
        filtered = base.filter(
          (item) => getInvoiceType(item) === "UNPAID",
        );
        break;

      default:
        filtered = base;
    }

    setDatas(filtered);
  }, [tab, currentYearData, originalData, searchingAllYears]);

  useEffect(() => {

    setSearchParams({
      search: globalFilter || "",
      page: pageIndex,
      pageSize,
    });

  }, [globalFilter, pageIndex, pageSize]);

  useEffect(() => setPageSize(50), []);

  const token = secureLocalStorage.getItem("auth_token");


  const onAddInvoice = async () => {
    const res = await fetchNodeData(
      setLoading,
      `ztplPerformaIndex/get/1`,
      token,
    );
    if (res?.status == 200) {
      setmodal_fullscreen(true);
      setAllOption(res?.data);
    }
  };

  useEffect(() => {
    const updateWidth = () => {
      const viewportWidth = window.innerWidth;
      setBoxWidth(viewportWidth * 0.5);
    };
    updateWidth();
    const hash = location?.hash?.split("-");
    if (hash[0] == "#lead") {
      onAddInvoice();
    }
  }, []);

  const closeModal = (close, load) => {
    setmodal_fullscreen(false);
    // if (load) {
    //   fetchInvoiceData()
    // }
  };

  const { totalAmount, receivedAmount, dueAmount } =
    useMemo(() => calculateFinancialYearTotals(currentYearData, 3, selectedFY), [currentYearData])

  const handleFilter = (e) => {
    e.preventDefault();

    if (
      fromDateFilter &&
      toDateFilter &&
      moment(fromDateFilter).isAfter(moment(toDateFilter))
    ) {
      Swal.fire({
        icon: "warning",
        title: "Invalid date range",
        text: "End date must be after the start date.",
      });
      console.warn("⚠️ Invalid date range:", fromDateFilter, ">", toDateFilter);
      return;
    }

    if (fromDateFilter || toDateFilter) {
      try {
        let filteredData = data ?? [];

        // Apply From Date Filter
        if (fromDateFilter) {
          const passedIds = [];
          const failedIds = [];

          filteredData = filteredData.filter((item) => {
            const invoiceDate = moment(item.invoice_date).startOf("day");
            const fromDate = moment(fromDateFilter).startOf("day");
            const result = invoiceDate.isSameOrAfter(fromDate);

            if (result) passedIds.push(item.id);
            else failedIds.push(item.id);

            return result;
          });
        }

        // Apply To Date Filter
        if (toDateFilter) {
          const passedIds = [];
          const failedIds = [];

          filteredData = filteredData.filter((item) => {
            const invoiceDate = moment(item.invoice_date).startOf("day");
            const toDate = moment(toDateFilter).startOf("day");
            const result = invoiceDate.isSameOrBefore(toDate);

            if (result) passedIds.push(item.id);
            else failedIds.push(item.id);

            return result;
          });
        }

        setDatas([...filteredData]);
        setActiveFilter(true)
      } catch (error) {
        console.error("❌ Error during filtering:", error);
        Swal.fire({
          icon: "error",
          title: "Something went wrong",
          text: "Unable to apply filters. Please try again.",
        });
      }
    } else {
      Swal.fire({
        icon: "warning",
        text: "Please enter at least one filter criterion to proceed.",
      });
      console.warn("⚠️ No filter criteria entered");
    }
  };

  const handleClear = () => {
    setFromDateFilter("");
    setToDateFilter("");
    fetchInvoiceData();
    setActiveFilter(false)
  };

  const stats = useMemo(() => {
    let fullyPaid = 0, partial = 0, unpaid = 0

    currentYearData.forEach(item => {
      const type = getInvoiceType(item)
      if (type === "FULLY_PAID") fullyPaid++
      else if (type === "PARTIAL") partial++
      else if (type === "UNPAID") unpaid++
      else console.log("⚠️ Unclassified Invoice:", item)
    })

    return { total: currentYearData.length, fullyPaid, partial, unpaid }
  }, [currentYearData])

  const TABS = [
    { title: "Total Invoices", value: stats.total },
    { title: "Fully Paid", value: stats.fullyPaid },
    { title: "Partially Paid", value: stats.partial },
    { title: "UnPaid", value: stats.unpaid },
  ]

  return (
    <div>
      <div
        className={`flex-column fixed-buttons pt-2 mt-3 ${fixedContent ? "d-flex" : "d-none"
          }`}
      >
        <Link
          onClick={() => onAddInvoice()}
          className="btn btn-save  fix-btn btn-label pe-0"
        >
          <i className="fas fa-plus me-2 icon-size label-icon"></i>
          <span>Payment</span>
        </Link>
      </div>
      <Row className="d-flex mt-4 text-end">
        <div className="d-flex col-md-10 justify-flex-start align-items-center gap-2">

          <div className="col-md-3 budget_status text-primary pt-2 px-2 me-3 rounded proposal-status text-center">
            <h6>Current Year</h6>
            {/* <h3>{getFinancialYear()}</h3> */}

            <select
              className="form-select2 form-select no-border-select w-100 fw-bold bg-transparent"
              style={{
                boxShadow: "none",
                width: "190px",
                border: "none",
                outline: "none",
                fontSize: "1.15rem",
                height: "2.5rem",
                lineHeight: "2.5rem",
                padding: "0 0.5rem",
                textAlign: "center",
                color: "#556ee6",
              }}
              onFocus={(e) => {
                e.target.style.boxShadow = "none";
                e.target.style.outline = "none";
                e.target.style.border = "none";
              }}
              onBlur={(e) => {
                e.target.style.boxShadow = "none";
              }}
              value={selectedFY}
              onChange={(e) => setSelectedFY(e.target.value)}
            >
              {financialYears.map((fy) => (
                <option key={fy} value={fy}>
                  {fy}
                </option>
              ))}
            </select>
          </div>
          <div className=" budget_status text-info pt-2 px-1 rounded proposal-status text-center">
            <h6>Total Invoice Amount </h6>
            <h3>₹ {totalAmount}</h3>
          </div>
          <div className=" budget_status text-success pt-2 px-2 rounded proposal-status text-center">
            <h6>Total Received Amount</h6>
            <h3>₹ {receivedAmount}</h3>
          </div>
          <div className=" budget_status text-danger pt-2 px-2 rounded proposal-status text-center">
            <h6>Total Due Amount</h6>
            <h3>₹ {dueAmount}</h3>
          </div>
        </div>
        <div className="col-md-2 text-end">
          <div className="">
            <button
              className=" btn btn-save btn-label"
              onClick={() => onAddInvoice()}
            >
              <i className="fas fa-plus me-2 label-icon"></i>
              Add Invoice
            </button>
          </div>
        </div>
      </Row>
      <Row className="m-0 d-flex justify-content-between align-items-center mt-4">
        <div className="p-0 col-md-7 d-flex align-items-center">
          <div>
            <select
              className="form-select"
              style={{ width: "100px" }}
              value={pageSize}
              onChange={(e) => setPageSize(e.target.value)}
            >
              {[10, 25, 50, 100].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
          </div>

          <div className="d-flex gap-3 align-items-center ms-3">
            {TABS.map((item, i) => (
              <div
                key={item.title}
                onClick={() => setTab(i)}
                className={`general-box cursor-pointer px-2 ${tab === i ? "bg-purple" : "text-purple"
                  } `}
              >
                {item.title} - <b>{item.value}</b>
              </div>
            ))}
          </div>
        </div>

        <div className="p-0 col-md-5 d-flex align-items-center justify-content-end gap-2">

          <button
            onClick={() => setFilterPopup(!filterPopup)}
            className={`btn ${activeFilter ? 'btn-success' : 'btn-outline-secondary'} me-3`}
          >
            <i className="fas fa-filter"></i> {activeFilter && 'Filter Applied!'}
          </button>

          <div className="search-box my-xxl-0 d-inline-block">
            <div className="position-relative">

              <label
                htmlFor="search-bar-0"
                className="search-label mb-0"
              >
                <span
                  id="search-bar-0-label"
                  className="sr-only"
                >
                  Search this table
                </span>

                <input
                  id="search-bar-0"
                  type="search"
                  className="form-control rounded h-100 pe-4"
                  placeholder="Search..."
                  value={globalFilter || ""}
                  onChange={(e) =>
                    setGlobalFilter(e.target.value)
                  }
                />
              </label>
              {
                globalFilter?.length > 0 &&
                <i className="fas fa-times search-icon"
                  onClick={() => setGlobalFilter("")}
                  style={{ left: 'auto', right: "10px" }}></i>
              }
              <i className="bx bx-search-alt search-icon"></i>
            </div>
          </div>
        </div>
      </Row>

      <div className="position-relative">
        <Table className="table table-bordered mt-4" {...getTableProps()}>
          <thead
            className={`${fixedContent ? "fix-headers" : ""
              } fix-introducer-header`}
          >
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    key={index}
                    className={`t-col-${index + 1} ${column.className}`}
                    {...column.getHeaderProps()}
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody className="fix-introducer-header" {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              const is_void = row?.original?.is_void;
              return (
                <tr
                  className={`row-hover ${is_void ? "bg-orange-void" : ""}`}
                  {...row.getRowProps()}
                  key={i}
                >
                  {row.cells.map((cell, index) => {
                    return (
                      <td
                        key={index}
                        className={`t-col-${index + 1} ${cell.column.className
                          }`}
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Pagination
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>

      {/* ================== Add  Modal ================== */}
      <Modal size="xl" isOpen={modal_fullscreen} className="modal-fullscreen">
        <AddZithasInvoice
          allOption={allOption}
          closeModal={closeModal}
          fetchInvoiceData={fetchInvoiceData}
        />
      </Modal>

      {filterPopup ? (
        <Draggable>
          <ResizableBox
            width={boxWidth}
            style={{
              position: "fixed",
              top: "30%",
              right: "3%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            {/* <div className="expense-filter">
                      <div className="popup-form p-4"> */}
            <Form
              onSubmit={handleFilter}
              className="row d-flex justify-content-center align-items-center"
            >
              <div className="col-md-12 d-flex ">
                <div className="col-md-3 ps-2">
                  <Label htmlFor="formrow-firstname-Input">From Date</Label>
                  <Input
                    type="date"
                    // required={toDateFilter ? true : false}
                    value={fromDateFilter}
                    onChange={(e) => setFromDateFilter(e.target.value)}
                  />
                </div>
                <div className="col-md-3 ps-2">
                  <Label htmlFor="formrow-firstname-Input">To Date</Label>
                  <Input
                    type="date"
                    value={toDateFilter}
                    onChange={(e) => setToDateFilter(e.target.value)}
                  />
                </div>

                <div className="col-md-6 d-flex justify-content-end align-items-center gap-2">
                  <button className="btn  btn-save btn-label me-1">
                    <i className="fas fa-filter search-icon label-icon"></i>{" "}
                    Filter
                  </button>
                  <a
                    className="btn  btn-danger"
                    style={{
                      fontSize: "14px",
                      backgroundColor: "#fed36d",
                      borderColor: "#fed36d",
                      color: "black",
                    }}
                    onClick={() => handleClear()}
                  >
                    Clear Filters
                  </a>

                  <a
                    className="btn btn-red btn-label me-1"
                    onClick={() => {
                      setFilterPopup(false);
                    }}
                  >
                    <i className="dripicons-cross label-icon"></i> Close
                  </a>
                </div>
              </div>
            </Form>
          </ResizableBox>
        </Draggable>
      ) : null}
    </div>
  );
}

const ZithasInvoice = () => {
  const [modal_fullscreen, setmodal_fullscreen] = useState(false);
  const [viewBill, setViewBill] = useState(false);
  const [paymentHistory, setPaymentHistory] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const roles = useSelector((state) => state?.Roles?.apiData);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") setEditModal(false);
  });

  //meta title
  document.title = "Zithas Invoice | Zithas Crm";

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") setmodal_fullscreen(false);
  });
  const [allOption, setAllOption] = useState([]);
  const [data, setDatas] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [currentYearData, setCurrentYearData] = useState([]);

  const [isLoading, setLoading] = useState(false);
  const [invoiceData, setInvoiceData] = useState({});
  const [modal_Access, setAccessDenied] = useState(false);
  const token = secureLocalStorage.getItem("auth_token");
  const [paymentOption, setPaymentOption] = useState([]);
  const [invoiceDetail, setInvoiceDetail] = useState({});
  const [transactionId, setTransactionId] = useState("");
  const [payment, setPayment] = useState([]);
  const [receivedDate, setReceivedDate] = useState("");
  const [amount, setAmount] = useState("");
  const [tds, setTds] = useState("");
  const [transactionCharge, setTransactionCharge] = useState("");
  const [description, setDescription] = useState("");
  const [historyData, setHistoryData] = useState([]);
  const [paymentMode, setPaymentMode] = useState(false);
  const [isEditMode, setEditMode] = useState(false);
  const [editingPaymentId, setEditingPaymentId] = useState(null);
  useEffect(() => {
    fetchInvoiceData();
  }, []);

  const fetchInvoiceData = async () => {
    const response = await fetchNodeData(setLoading, `zithasInvoice`, token);
    if (response?.status == 200) {
      setOriginalData(response?.data);

      // const filtered = getByFinancialYear(response?.data)

      // setDatas(filtered);

      const res = await fetchData(() => { }, "financeModes", token);
      if (res?.success) {
        setPaymentOption(
          res?.data?.map((obj) => ({
            value: obj?.id,
            label: obj?.payment_mode,
          })),
        );
      }
    }
  };

  const onEditInvoice = async (obj, view) => {
    const permission = checkPermissionsByModule(roles, 45, 4);
    if (permission) {
      const res = await fetchNodeData(
        setLoading,
        `ztplPerformaIndex/get/1`,
        token,
      );
      if (res?.status == 200) {
        setAllOption(res?.data);
        setInvoiceData(obj);
        setEditModal(true);
      }
    } else {
      setAccessDenied(true);
    }
  };

  const isClone = async (id) => {
    const permission = checkPermissionsByModule(roles, 45, 3);
    if (permission) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to clone this Invoice?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Clone it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const res = await fetchNodeData(
            setLoading,
            `zithasInvoice/clone/${localStorage.getItem("auth_id")}/${id}`,
            token,
          );
          if (res?.status == 200) {
            Swal.fire("Success", "Invoice has been cloned", "success");
            fetchInvoiceData();
          }
        }
      });
    } else {
      setAccessDenied(true);
    }
  };

  const onVoid = (id, type) => {
    const permission = checkPermissionsByModule(roles, 45, 4);
    if (permission) {
      Swal.fire({
        title: "Are you sure?",
        text: `Do you really want to ${type == 0 ? "Void" : "Unvoid"
          } this Invoice?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#762C99",
        confirmButtonText: `Yes, ${type == 0 ? "Void" : "Unvoid"} it!`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            setLoading(true);
            const res = await axios.get(
              `${configure.nodeApi}/zithasInvoice/void/${localStorage.getItem(
                "auth_id",
              )}/${id}`,
            );
            setLoading(false);
            if (res?.data?.status == 200) {
              Swal.fire(
                `${type == 0 ? "Voided" : "Unvoided"}!`,
                `The Invoice has been ${type == 0 ? "Voided" : "Unvoided"}`,
                "success",
              );
              fetchInvoiceData();
            }
          } catch (e) {
            setLoading(false);
            Swal.fire("Error", "Something Went Wrong", "error");
          }
        }
      });
    } else {
      setAccessDenied(true);
    }
  };

  const onToggleReminder = async (rowData) => {
    const turningOn = Number(rowData?.include_in_reminder) !== 1
    try {
      setLoading(true)
      await axios.put(`${configure.nodeApi}/invoiceReminderFlag`, {
        invoice_type: "zithas",
        invoice_id: rowData.id,
        include_in_reminder: turningOn ? 1 : 0,
      })
      setLoading(false)
      fetchInvoiceData()
    } catch (e) {
      setLoading(false)
      Swal.fire("Error", "Something Went Wrong", "error")
    }
  }

  const ondelete = (id) => {
    const permission = checkPermissionsByModule(roles, 45, 5);
    if (permission) {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to delete this Invoice?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#762C99",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            setLoading(true);
            const res = await axios.delete(
              `${configure.nodeApi}/zithasInvoice/${localStorage.getItem(
                "auth_id",
              )}/${id}`,
            );
            setLoading(false);
            if (res?.data?.status == 200) {
              Swal.fire("Deleted!", "The Invoice has been deleted.", "success");
              fetchInvoiceData();
            }
          } catch (e) {
            setLoading(false);
            Swal.fire("Error", "Something Went Wrong", "error");
          }
        }
      });
    } else {
      setAccessDenied(true);
    }
  };
  const onPaymentRecord = async (obj) => {
    const permission = checkPermissionsByModule(roles, 45, 4);
    if (permission) {
      const res = await fetchNodeData(
        setLoading,
        `paymentHistory/${obj?.id}`,
        token,
      );
      if (res?.success) {
        setHistoryData(res?.data?.history);
        setPaymentMode(true);
        setInvoiceDetail({
          ...obj,
          due_amount: res?.data?.due_amount,
        });
      }
    } else {
      setAccessDenied(true);
    }
  };

  const fmtAmt = num => Number(num || 0).toFixed(2)

  const getLogoBase64 = async () => {
    const res = await fetch(zithasLogo)
    const blob = await res.blob()
    return new Promise(resolve => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result)
      reader.readAsDataURL(blob)
    })
  }

  const receiptCss = `
    *{box-sizing:border-box;margin:0;padding:0;}
    .rc-doc{background:#fff;width:620px;font-family:'Poppins',Arial,sans-serif;font-size:13px;color:#212529;overflow:hidden;border:1px solid #dee2e6;}
    .rc-header{padding:20px 24px 16px;display:flex;justify-content:space-between;align-items:flex-start;border-bottom:1px solid #dee2e6;}
    .rc-h-left .rc-title{font-size:19px;font-weight:600;color:#212529;letter-spacing:0.2px;}
    .rc-h-left .rc-subtitle{font-size:10px;font-weight:400;text-transform:uppercase;letter-spacing:1.4px;color:#212529;opacity:0.4;margin-top:3px;}
    .rc-h-right{display:flex;flex-direction:column;align-items:flex-end;gap:5px;}
    .rc-logo{height:45px;object-fit:contain;}
    .rc-amt-card{margin:16px 20px;padding:16px 20px;display:flex;justify-content:space-between;align-items:center;border:1px solid #dee2e6;border-radius:4px;}
    .rc-amt-lbl{font-size:10px;font-weight:400;text-transform:uppercase;letter-spacing:1.3px;color:#212529;opacity:0.45;margin-bottom:5px;}
    .rc-amt-val{font-size:24px;font-weight:600;color:#212529;font-variant-numeric:tabular-nums;}
    .rc-badge{background:#e6f4ed;color:#1a6b47;font-size:10px;font-weight:500;text-transform:uppercase;letter-spacing:0.6px;padding:5px 13px;border-radius:20px;border:1px solid #8fcfab;white-space:nowrap;}
    .rc-badge-paid{background:#eef2ff;color:#3b4fcc;font-size:10px;font-weight:500;text-transform:uppercase;letter-spacing:0.6px;padding:5px 13px;border-radius:20px;border:1px solid #a5b4fc;white-space:nowrap;}
    .rc-grid{display:grid;grid-template-columns:1fr 1fr;padding:4px 20px 16px;}
    .rc-col{padding:12px 8px;}
    .rc-col:first-child{border-right:1px solid #dee2e6;padding-right:20px;}
    .rc-col:last-child{padding-left:20px;}
    .rc-item{margin-bottom:13px;}
    .rc-item:last-child{margin-bottom:0;}
    .rc-lbl{font-size:10px;font-weight:400;text-transform:uppercase;letter-spacing:1px;color:#212529;opacity:0.45;margin-bottom:3px;}
    .rc-v{font-size:13px;font-weight:500;color:#212529;}
    .rc-v-sub{font-size:12px;font-weight:400;color:#212529;opacity:0.6;margin-top:2px;}
    .rc-divh{height:1px;background:#dee2e6;margin:0 20px;}
    .rc-net{margin:16px 20px 0;padding:14px 20px;border:1px solid #dee2e6;border-bottom:none;border-radius:4px 4px 0 0;}
    .rc-net-row{display:flex;justify-content:space-between;align-items:center;padding:6px 0;border-bottom:1px solid #dee2e6;font-size:13px;font-weight:400;color:#212529;}
    .rc-net-row:last-child{border-bottom:none;}
    .rc-net-row.net-total{font-weight:600;color:#212529;font-size:13px;text-transform:uppercase;letter-spacing:0.3px;padding-top:9px;margin-top:2px;}
    .rc-net-row.net-tds span:last-child{color:#c0392b;font-weight:500;}
    .rc-net-v{font-variant-numeric:tabular-nums;}
    .rc-due{background:#212529;margin:0 20px 16px;padding:13px 20px;border-radius:0 0 4px 4px;display:flex;justify-content:space-between;align-items:center;}
    .rc-due-lbl{font-size:10px;font-weight:400;text-transform:uppercase;letter-spacing:1px;color:#fff;opacity:0.7;}
    .rc-due-val{font-size:15px;font-weight:600;color:#fff;font-variant-numeric:tabular-nums;}
    .rc-net-closed{margin:0 20px 16px;border:1px solid #dee2e6;border-top:none;border-radius:0 0 4px 4px;height:14px;}
    .rc-note{margin:0 20px 12px;padding:9px 12px;border-left:3px solid #212529;font-size:12px;font-weight:400;color:#212529;line-height:1.6;}
    .rc-note strong{font-weight:600;color:#212529;}
  `

  const buildReceiptBody = (payment, logoSrc) => {
    const sym = invoiceDetail?.currency_symbol || "₹"
    const tdsAmt = Number(payment.tds || 0)
    const invoiceAmt = Number(invoiceDetail?.total || 0)
    const sortedHistory = [...(historyData || [])].sort((a, b) => {
      const dateDiff = new Date(a.receive_date) - new Date(b.receive_date)
      return dateDiff !== 0 ? dateDiff : (a.id || 0) - (b.id || 0)
    })
    const currentIndex = sortedHistory.findIndex(p => p.id === payment.id)
    const previousPayments =
      currentIndex > 0 ? sortedHistory.slice(0, currentIndex) : []
    const previousTotal = previousPayments.reduce(
      (sum, p) => sum + Number(p.amount || 0),
      0
    )
    const previousTdsTotal = previousPayments.reduce(
      (sum, p) => sum + Number(p.tds || 0),
      0
    )
    const totalTdsAmt = previousTdsTotal + tdsAmt
    const due = Math.max(
      Number(
        (
          invoiceAmt -
          previousTotal -
          Number(payment.amount || 0) -
          totalTdsAmt
        ).toFixed(2)
      ),
      0
    )
    const note = payment.description || payment.payment_details || ""
    const gstValue = (invoiceDetail?.c_vatnumber || "").trim()
    const companyValue = (invoiceDetail?.c_company || "").trim().toLowerCase()
    const hasValidGst = gstValue && gstValue.toLowerCase() !== companyValue
    return `
<div class="rc-doc">
  <div class="rc-header">
    <div class="rc-h-left">
      <div class="rc-title">PAYMENT RECEIPT</div>
      <div class="rc-subtitle">Transaction Record</div>
    </div>
    <div class="rc-h-right">
      <img src="${logoSrc}" class="rc-logo" alt="Logo"/>
    </div>
  </div>
  <div class="rc-amt-card">
    <div>
      <div class="rc-amt-lbl">Amount Received</div>
      <div class="rc-amt-val">${sym} ${fmtAmt(payment.amount)}</div>
    </div>
    <div style="display:flex;gap:6px;">
      <div class="rc-badge">&#10003; Successfully Processed</div>
      ${due === 0 ? `<div class="rc-badge-paid">&#10003; Fully Paid</div>` : ""}
    </div>
  </div>
  <div class="rc-grid">
    <div class="rc-col">
      <div class="rc-item"><div class="rc-lbl">Receipt Number</div><div class="rc-v">${payment?.id ? `ZI-${payment.id}` : "—"}</div></div>
      <div class="rc-item"><div class="rc-lbl">Date of Issue</div><div class="rc-v">${moment(payment.receive_date).format("DD MMMM YYYY")}</div></div>
      <div class="rc-item"><div class="rc-lbl">Payment Mode</div><div class="rc-v">${payment.payment_mode || "—"}</div></div>
      ${payment.transaction_id ? `<div class="rc-item"><div class="rc-lbl">Transaction ID</div><div class="rc-v">#${payment.transaction_id}</div></div>` : ""}
      ${totalTdsAmt > 0 ? `<div class="rc-item"><div class="rc-lbl">TDS (Total to Date)</div><div class="rc-v">${sym} ${fmtAmt(totalTdsAmt)}</div></div>` : ""}
    </div>
    <div class="rc-col">
      <div class="rc-item">
        <div class="rc-lbl">Received From</div>
        <div class="rc-v">${invoiceDetail?.c_company || "—"}</div>
        ${invoiceDetail?.c_address ? `<div class="rc-v-sub">${invoiceDetail.c_address}</div>` : ""}
        ${[invoiceDetail?.city_name, invoiceDetail?.state_name, invoiceDetail?.country_name].filter(Boolean).length
        ? `<div class="rc-v-sub">${[invoiceDetail?.city_name, invoiceDetail?.state_name, invoiceDetail?.country_name].filter(Boolean).join(", ")}${invoiceDetail?.c_zipcode ? ` - ${invoiceDetail.c_zipcode}` : ""}</div>`
        : ""}
      </div>
      <div class="rc-item"><div class="rc-lbl">GST Number</div><div class="rc-v">${hasValidGst ? invoiceDetail.c_vatnumber : "—"}</div></div>
    </div>
  </div>
  <div class="rc-divh"></div>
  <div class="rc-net">
    <div class="rc-net-row"><span>Invoice Amount</span><span class="rc-net-v">${sym} ${fmtAmt(invoiceAmt)}</span></div>
    ${previousPayments.length
        ? previousPayments
          .map(
            p => `<div class="rc-net-row"><span>Received ${moment(p.receive_date).format("DD MMM YYYY")}${p.payment_mode ? ` (${p.payment_mode})` : ""}</span><span class="rc-net-v">${sym} ${fmtAmt(p.amount)}</span></div>`
          )
          .join("")
        : ""}
    <div class="rc-net-row net-total"><span>This Receipt (Amount Received)</span><span class="rc-net-v">${sym} ${fmtAmt(payment.amount)}</span></div>
  </div>
  <div class="rc-due"><span class="rc-due-lbl">Remaining Amount Due</span><span class="rc-due-val">${sym} ${fmtAmt(due)}</span></div>
  ${note ? `<div class="rc-note"><strong>Note:</strong> ${note}</div>` : ""}
</div>`
  }

  const buildReceiptHtml = (payment, logoSrc) =>
    `<!DOCTYPE html><html><head><meta charset="UTF-8"/><title>Payment Receipt</title>
<style>body{background:#f0f2f5;display:flex;justify-content:center;padding:24px;}${receiptCss}</style>
</head><body>${buildReceiptBody(payment, logoSrc)}</body></html>`

  const onDownloadReceipt = async payment => {
    setLoading(true)
    try {
      const logoSrc = await getLogoBase64()
      const styleEl = document.createElement("style")
      styleEl.textContent = receiptCss
      document.head.appendChild(styleEl)
      const container = document.createElement("div")
      container.style.cssText = "position:fixed;left:-9999px;top:0;width:794px;"
      container.innerHTML = buildReceiptBody(payment, logoSrc)
      document.body.appendChild(container)
      const el = container.querySelector(".rc-doc")
      el.style.width = "100%"

      const opt = {
        margin: 0,
        filename: `receipt-${(invoiceDetail?.tax_inv_no || "").replace(/\//g, "-")}-${moment(payment.receive_date).format("DDMMYYYY")}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, letterRendering: true, useCORS: true },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      }
      await html2pdf().from(el).set(opt).save()
      document.body.removeChild(container)
      document.head.removeChild(styleEl)
    } catch (err) {
      console.error("Receipt PDF failed", err)
      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: err?.message || String(err),
      })
    } finally {
      setLoading(false)
    }
  }

  const onOpenReceiptTab = async payment => {
    const logoSrc = await getLogoBase64()
    const newTab = window.open("", "_blank")
    if (newTab) {
      newTab.document.write(buildReceiptHtml(payment, logoSrc))
      newTab.document.close()
    }
  }

  const onDeletePaymentRecord = payment => {
    const permission = checkPermissionsByModule(roles, 45, 5)
    if (!permission) { setAccessDenied(true); return }
    Swal.fire({
      title: "Are you sure?",
      text: `Delete payment of ${invoiceDetail?.currency_symbol || "₹"} ${payment.amount} received on ${moment(payment.receive_date).format("DD-MM-YYYY")}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          const user_id = localStorage.getItem("auth_id")
          const res = await FetchNodeDeleteData(
            setLoading,
            `zithasInvoice/payment/${user_id}`,
            payment.id
          )
          if (res?.data?.success) {
            Swal.fire("Deleted!", "Payment record has been deleted.", "success")
            await onPaymentRecord(invoiceDetail)
          } else {
            Swal.fire("Error", res?.data?.message || "Failed to delete.", "error")
          }
        } catch (err) {
          Swal.fire("Error", "Something went wrong.", "error")
        }
      }
    })
  }

  const columns = useMemo(
    () =>
      zithasTaxInvoice(
        onEditInvoice,
        isClone,
        onVoid,
        ondelete,
        onPaymentRecord,
        onToggleReminder,
      ),
    [],
  );

  const closeModal = (close, load) => {
    setEditModal(false);
    if (load) {
      fetchInvoiceData();
    }
  };

  const onAddPayment = async (e) => {
    e.preventDefault();
    if (!payment) {
      Swal.fire({ icon: "warning", text: "Please select a Payment Mode." })
      return
    }
    if (!receivedDate) {
      Swal.fire({ icon: "warning", text: "Please select a Received Date." })
      return
    }
    if (!amount) {
      Swal.fire({ icon: "warning", text: "Please enter an Amount." })
      return
    }
    let exchangeRate = 1; // default to 1

    if (invoiceDetail?.currency_name !== "INR") {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://api.frankfurter.dev/v1/${receivedDate}?from=${invoiceDetail?.currency_name}&to=INR`
        );
        setLoading(false);
        const rate = response.data.rates.INR;
        const { value } = await Swal.fire({
          title: "Exchange Rate Fetched",
          html: `<b>1 ${invoiceDetail?.currency_name} = ${rate.toFixed(2)} INR</b><br/><small>Confirm or enter a different rate.</small>`,
          input: "text",
          inputValue: rate.toFixed(2),
          showCancelButton: false,
          allowOutsideClick: false,
          confirmButtonText: "Confirm",
          inputValidator: val => {
            if (!val || isNaN(val) || Number(val) <= 0) return "Please enter a valid exchange rate."
          },
        });
        if (value) exchangeRate = Number(value);
      } catch (error) {
        console.error("Failed to fetch exchange rate:", error);
        setLoading(false);
        const { value } = await Swal.fire({
          title: "Exchange Rate Not Available",
          text: `Could not fetch rate for ${invoiceDetail?.currency_name}. Please enter it manually.`,
          input: "text",
          inputPlaceholder: `1 ${invoiceDetail?.currency_name} = ? INR`,
          showCancelButton: false,
          allowOutsideClick: false,
          confirmButtonText: "Set Rate",
          inputValidator: val => {
            if (!val || isNaN(val) || Number(val) <= 0) return "Please enter a valid exchange rate."
          },
        })
        if (value) exchangeRate = Number(value)
      } finally {
        setLoading(false);
      }
    }

    const formEntries = {
      invoice_id: invoiceDetail?.id,
      amount: amount,
      exchange_rate: invoiceDetail?.currency_name !== "INR" ? exchangeRate : 1,
      payment_mode: payment?.label,
      tds: tds || 0,
      receive_date: receivedDate,
      transaction_charge: transactionCharge || 0,
      transaction_id: transactionId,
      transaction_detail: description,
    };

    const res = await FetchNodePostData(
      setLoading,
      `invoicePaymentRecord`,
      token,
      formEntries,
    );

    if (res?.data?.success) {
      Swal.fire({
        icon: "success",
        title: "Payment Record Added Successfully",
      }).then(() => {
        setHistoryData(res?.data?.data.history);
        resetForm();
        setInvoiceDetail({
          ...invoiceDetail,
          due_amount: res?.data?.data?.due_amount,
        });
      });
    }
  };

  const onEdit = (obj) => {
    if (isEditMode && editingPaymentId === obj.id) {
      resetForm();
    } else {
      setTransactionId(obj.transaction_id || "");
      setPayment({ label: obj.payment_mode, value: obj.payment_mode });
      setReceivedDate(obj.receive_date);
      setAmount(obj.amount);
      setTds(obj.tds || "");
      setTransactionCharge(obj.transaction_charge || "");
      setDescription(obj.transaction_detail || "");
      setEditMode(true);
      setEditingPaymentId(obj.id);
    }
  };

  const resetForm = () => {
    setTransactionId("");
    setPayment([]);
    setReceivedDate("");
    setAmount("");
    setTds("");
    setTransactionCharge("");
    setDescription("");
    setEditMode(false);
    setEditingPaymentId(null);
  };

  const onEditPayment = async (e) => {
    e.preventDefault();
    const formEntries = {
      id: editingPaymentId,
      receive_date: receivedDate,
      payment_details: description,
      amount: amount,
      tds: tds || 0,
      transaction_charge: transactionCharge || 0,
      transaction_id: transactionId,
      payment_mode: payment?.label,
      user_id: localStorage.getItem("auth_id"),
    };

    const res = await axios.post(
      `${configure.nodeApi}/editPaymentMethod/zithas`,
      formEntries,
    );
    if (res?.status === 200) {
      Swal.fire({
        icon: "success",
        title: "Payment Record Updated Successfully",
      }).then(async () => {
        resetForm();
        await onPaymentRecord(invoiceDetail);
      });
    }
  };

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Zithas Invoice"} />
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <TableContainer
                      columns={columns}
                      data={data}
                      setDatas={setDatas}
                      setAccessDenied={setAccessDenied}
                      setLoading={setLoading}
                      fetchInvoiceData={fetchInvoiceData}
                      originalData={originalData}
                      setOriginalData={setOriginalData}
                      currentYearData={currentYearData}
                      setCurrentYearData={setCurrentYearData}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/*  ================== Payment History  Modal  ==================*/}
      <Modal isOpen={paymentHistory} size="xl" className="" centered>
        <div className="modal-header pe-4">
          <h5 className="modal-title mt-0">Paid Payment List</h5>
          <button
            type="button"
            onClick={() => {
              setPaymentHistory(false);
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>

        <div className="modal-body pe-4 my-5">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-4 d-flex justify-content-end align-items-center ps-3">
              <div className="text-center">
                <img src={viewbill} alt="Addepe" style={{ width: "80%" }} />
              </div>
            </div>
            <div className="col-md-8">
              <Table bordered hover responsive size="" striped>
                <thead>
                  <tr>
                    <th className="text-center bill-col-1">ID</th>
                    <th className="bill-col-2">Received Date</th>
                    <th className="bill-col-3 text-center">Payment Mode</th>
                    <th className="bill-col-4 text-center">Amount</th>
                    <th className="bill-col-5 text-center">TDS</th>
                    <th className="bill-col-6 text-center">
                      Transaction Charge
                    </th>
                    <th className="text-center bill-col-7">Created Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td scope="row" className="text-center bill-col-1">
                      1
                    </td>
                    <td className="bill-col-2">30-6-2024</td>
                    <td className="bill-col-3 text-center">Cash</td>
                    <td className="bill-col-4 text-center">1000</td>
                    <td className="bill-col-4 text-center">12%</td>
                    <td className="bill-col-4 text-center">1000</td>
                    <td className="text-center bill-col-5">
                      30-6-2024 13:30:35
                    </td>
                  </tr>
                  <tr>
                    <td scope="row" className="text-center bill-col-1">
                      2
                    </td>
                    <td className="bill-col-2">30-6-2024</td>
                    <td className="bill-col-3 text-center">Cash</td>
                    <td className="bill-col-4 text-center">1000</td>
                    <td className="bill-col-4 text-center">12%</td>
                    <td className="bill-col-4 text-center">1000</td>
                    <td className="text-center bill-col-5">
                      30-6-2024 13:30:35
                    </td>
                  </tr>
                  <tr>
                    <td scope="row" className="text-center bill-col-1">
                      3
                    </td>
                    <td className="bill-col-2">30-6-2024</td>
                    <td className="bill-col-3 text-center">Cash</td>
                    <td className="bill-col-4 text-center">1000</td>
                    <td className="bill-col-4 text-center">12%</td>
                    <td className="bill-col-4 text-center">1000</td>
                    <td className="text-center bill-col-5">
                      30-6-2024 13:30:35
                    </td>
                  </tr>
                  <tr>
                    <td scope="row" className="text-center bill-col-1">
                      4
                    </td>
                    <td className="bill-col-2">30-6-2024</td>
                    <td className="bill-col-3 text-center">Cash</td>
                    <td className="bill-col-4 text-center">1000</td>
                    <td className="bill-col-4 text-center">12%</td>
                    <td className="bill-col-4 text-center">1000</td>
                    <td className="text-center bill-col-5">
                      30-6-2024 13:30:35
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={paymentMode}
        size="xl"
        className="payment-records"
        centered
      >
        <div className="modal-header pe-4">
          <div className="d-flex gap-2 align-items-center">
            <h5 className="modal-title mt-0">Payment Record</h5>
            <span className="mb-0 px-3 py-1 bg-success rounded text-light">
              Total Amount:{" "}
              <span>{Number(invoiceDetail?.total).toFixed(2)}</span>
            </span>
            <span className="mb-0 px-3 py-1 bg-danger rounded text-light">
              Due Amount:{" "}
              <span>{Number(invoiceDetail?.due_amount).toFixed(2)}</span>
            </span>
          </div>
          <button
            type="button"
            onClick={() => {
              fetchInvoiceData();
              setPaymentMode(false);
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              ×
            </span>
          </button>
        </div>

        <div className="modal-body pe-4">
          <div className="d-flex justify-content-between">
            <div className="col-md-6 ps-3 border-right">
              <h6 className="mb-4 text-dark">Payment History</h6>
              <Table
                bordered
                hover
                responsive
                size=""
                striped
                className="w-100"
              >
                <thead>
                  <tr>
                    <th className="bill-col-2">Received Date</th>
                    <th className="bill-col-3 text-center">Payment</th>
                    <th className="bill-col-4 text-center">Amount</th>
                    <th className="bill-col-6 text-center">Transaction</th>
                    <th className="text-center">TDS</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {historyData?.map((obj, i) => (
                    <tr key={i}>
                      <td className="bill-col-2">
                        {moment(obj?.receive_date).format("DD-MM-YYYY")}
                      </td>
                      <td className="bill-col-3 text-center">
                        {obj?.payment_mode}
                      </td>
                      <td className="bill-col-4 text-center">
                        {fmtAmt(obj?.amount)}
                      </td>
                      <td className="bill-col-4 text-center">
                        {obj?.transaction_id}
                      </td>
                      <td className="text-center">{obj?.tds || "-"}</td>
                      <td className="text-center" style={{ whiteSpace: "nowrap" }}>
                        <button
                          className="btn btn-sm btn-outline-secondary me-1"
                          onClick={() => onEdit(obj)}
                        >
                          <i
                            className={`bi ${isEditMode && editingPaymentId === obj.id
                              ? "bi-x-lg"
                              : "bi-pencil-fill"
                              }`}
                          ></i>
                        </button>
                        <button
                          className="btn btn-sm btn-outline-primary me-1"
                          title="Download Receipt"
                          onClick={() => onDownloadReceipt(obj)}
                        >
                          <i className="fas fa-download"></i>
                        </button>
                        <button
                          className="btn btn-sm btn-outline-info me-1"
                          title="Open Receipt in New Tab"
                          onClick={() => onOpenReceiptTab(obj)}
                        >
                          <i className="fas fa-external-link-alt"></i>
                        </button>
                        <button
                          className="btn btn-sm btn-outline-danger"
                          title="Delete Payment Record"
                          onClick={() => onDeletePaymentRecord(obj)}
                        >
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div className="info_box_1"></div>

            <form
              className="col-md-5 d-flex flex-column"
              onSubmit={isEditMode ? onEditPayment : onAddPayment}
            >
              <div className="col-md-12 row mb-4 justify-content-start align-items-end">
                <div className="col-4">
                  <Label htmlFor="formrow-firstname-Input">
                    Transaction ID
                  </Label>
                  <Input
                    type="text"
                    className="form-control"
                    placeholder="Transaction ID"
                    value={transactionId}
                    onChange={(e) => setTransactionId(e.target.value)}
                  />
                </div>

                <div className="col-4">
                  <Label htmlFor="formrow-firstname-Input">
                    Payment Mode <span className="text-danger">*</span>
                  </Label>
                  <Select
                    placeholder="Payment"
                    className="basic-multi-select"
                    classNamePrefix="select"
                    styles={colourStyles}
                    options={paymentOption}
                    value={payment}
                    onChange={(e) => setPayment(e)}
                  />
                </div>
                <div className="col-4">
                  <Label htmlFor="formrow-firstname-Input">
                    Received Date <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="date"
                    className="form-control"
                    value={receivedDate}
                    onChange={(e) => setReceivedDate(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end gap-3">
                <div className="col-3">
                  <Label htmlFor="formrow-firstname-Input">
                    Amount <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    className="form-control"
                    placeholder="Enter Amount"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    onBlur={(e) => {
                      if (Number(amount) > Number(invoiceDetail?.due_amount)) {
                        Swal.fire({
                          icon: "warning",
                          text: "Oops! You can't enter more than Due Amount",
                        });
                        setAmount("");
                      }
                    }}
                  //disabled={isEditMode}
                  />
                </div>
                <div className="col-3">
                  <Label htmlFor="formrow-firstname-Input">TDS</Label>
                  <Input
                    type="text"
                    className="form-control"
                    placeholder="Enter TDS"
                    value={tds}
                    onChange={(e) => setTds(e.target.value)}
                  />
                </div>
                <div className="col-3">
                  <Label htmlFor="formrow-firstname-Input">
                    Transaction Charge
                  </Label>
                  <Input
                    type="text"
                    className="form-control"
                    placeholder="Enter Charge"
                    value={transactionCharge}
                    onChange={(e) => setTransactionCharge(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end flex-column gap-4">
                <div className="col-12 ps-2">
                  <label htmlFor="">Transaction Details</label>
                  <div>
                    <CKEditor
                      editor={ClassicEditor}
                      onReady={(editor) => { }}
                      data={description || ""}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setDescription(data);
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="text-right">
                <button className="btn btn-save btn-label" type="submit">
                  <i className="fas fa-save me-2 label-icon"></i>
                  {isEditMode ? "Update" : "Save"}
                </button>
                <a
                  onClick={() => {
                    resetForm();
                    fetchInvoiceData();
                    setPaymentMode(false);
                  }}
                  className="btn ms-md-2 btn-red btn-label"
                >
                  <i className="dripicons-cross me-2 icon-center label-icon"></i>
                  CANCEL
                </a>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      {/* ================== Edit  Modal ================== */}
      <Modal size="xl" isOpen={editModal} className="modal-fullscreen">
        <EditZithasInvoice
          allOption={allOption}
          closeModal={closeModal}
          invoiceData={invoiceData}
        />
      </Modal>

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </React.Fragment>
  );
};

export default ZithasInvoice;
